import { INVESTOR } from '@/constants/testIds';

export const Footer = () => (
  <footer
    data-testid={INVESTOR.footer}
    className="border-t border-border bg-[#0a0b0e]"
  >
    <div className="mx-auto max-w-screen-2xl px-6 md:px-12 py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
      <div>
        <div className="font-display text-3xl tracking-tight text-foreground">
          Zukunft Real Estate<span className="text-primary"> GmbH</span>
        </div>
        <p className="mt-3 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-muted-foreground">
          Investisseur indépendant — Angel &amp; Venture
        </p>
      </div>

      <div className="flex items-center gap-8">
        {['LinkedIn', 'X / Twitter', 'Email'].map((l) => (
          <a
            key={l}
            href="#contact"
            className="link-underline font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground transition-colors duration-300"
          >
            {l}
          </a>
        ))}
      </div>
    </div>
    <div className="mx-auto max-w-screen-2xl px-6 md:px-12 pb-10">
      <div className="h-px w-full bg-border mb-6" />
      <p className="font-mono text-[0.6rem] uppercase tracking-[0.2em] text-muted-foreground">
        © {new Date().getFullYear()} Zukunft Real Estate GmbH — Tous droits réservés
      </p>
    </div>
  </footer>
);
